import { Navigate, useLocation } from 'react-router-dom'
import { useUserStore } from '@/stores/userStore'

/**
 * 受保护的路由组件
 * 用于检查用户登录状态，未登录时重定向到登录页
 */
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { currentUser } = useUserStore()
  const location = useLocation()

  // 如果用户未登录，重定向到登录页，并保存当前路径以便登录后返回
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

